/* eslint-disable import/prefer-default-export */
import { makeEntityScaffold } from '@classpass/saga-tools';
export var scheduleById = makeEntityScaffold('SAGA.API.GET_SCHEDULE_BY_ID', function (client, scheduleId, options) {
  return client.schedules.getScheduleById(scheduleId, options);
}, {
  defaultKey: 1
});